<template>
  <div class="card-container">
    <div class="c-header-container">
      <div class="c-header">
        SYSTEMS BY HEALTH RATING
      </div>
    </div>
    <div class="c-graph-container">
      <img
        v-if="loadingTableData"
        src="@shared/assets/img/general/loading-white.svg"
        class="loading"
        alt="loading"
      >
      <div
        v-else-if="tableData.length === 0"
        class="sac__font-14 f-white n40"
      >
        No system
      </div>
      <div
        v-else
        class="c-graph"
      >
        <div class="c-chart-container">
          <highcharts
            class="c-chart"
            :options="chartOptions"
          />
        </div>
        <div class="c-legend-container">
          <div class="c-legend">
            <div class="c-legend-green" />
            <div class="c-legend-label">
              Normal
            </div>
          </div>
          <div class="c-legend">
            <div class="c-legend-yellow" />
            <div class="c-legend-label">
              Mild
            </div>
          </div>
          <div class="c-legend">
            <div class="c-legend-red" />
            <div class="c-legend-label">
              Severe
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemHealthMixin from '@shared/mixins/systemHealthMixin';

export default {
  name: 'SystemHealthRating',
  mixins: [systemHealthMixin],
  computed: {
    chartOptions() {
      const title = `${this.tableData.length}<br>TOTAL SYSTEMS`;

      const allSystemHealth = {};

      this.tableData.forEach((t) => {
        const {
          systemHealthRating,
        } = t;
        if (systemHealthRating) {
          if (allSystemHealth[systemHealthRating]) {
            allSystemHealth[systemHealthRating] += 1;
          } else {
            allSystemHealth[systemHealthRating] = 1;
          }
        }
      });

      const chartData = Object.keys(allSystemHealth).map((key) => {
        let color = '#4CD87D';
        if (key === 'Mild') {
          color = '#FFAB00';
        }
        if (key === 'Severe') {
          color = '#F7433A';
        }
        return {
          name: key,
          y: allSystemHealth[key],
          color,
        };
      });

      return {
        chart: {
          backgroundColor: 'transparent',
          width: null,
          height: null,
          spacingTop: -20,
          spacingBottom: -40,
          spacingRight: 20,
          spacingLeft: 20,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: title,
          align: 'center',
          verticalAlign: 'middle',
          y: 30,
          style: {
            color: '#FFFFFF',
            fontSize: 12,
            fontWeight: '600',
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '120%',
          },
        },
        series: [{
          type: 'pie',
          name: 'Systems',
          innerSize: '90%',
          data: chartData,
        }],
      };
    },
  },
};
</script>
